export default "__VITE_ASSET__Dlg$QQuD__"